import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const getCaseStudyById = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/CaseStudies/${id}`);
    return data || null;
  } catch (error) {
    console.error("Error fetching case study by id:", error);
    return null;
  }
};

const useCaseStudyById = (id) => {
  return useQuery({
    queryKey: ["caseStudy", id],
    queryFn: () => getCaseStudyById(id),
    enabled: !!id,
    keepPreviousData: true,
  });
};

export default useCaseStudyById;

